import React, { useRef } from 'react';
import BulkUploadHelp from './BulkUploadHelp';
import logo from '../../assets/images/Logo.png';

type BulkExcelActionsProps = {
  helpTargetId?: string;
  onDownload: () => void;
  onUpload: (file: File) => void | Promise<void>;
  containerClassName?: string;
  helpClassName?: string;
  actionsClassName?: string;
  disabled?: boolean;
  downloadDisabled?: boolean;
  downloadLabel?: string;
  uploadLabel?: string;
};

export const BulkExcelLoadingOverlay = () => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      zIndex: 9999,
    }}
  >
    <img
      src={logo}
      alt="Loading..."
      style={{
        width: 120,
        height: 120,
        objectFit: 'contain',
      }}
    />
  </div>
);

const BulkExcelActions = ({
  helpTargetId,
  onDownload,
  onUpload,
  containerClassName,
  helpClassName = 'text-muted fw-medium mb-2 mt-2',
  actionsClassName = 'd-flex flex-wrap gap-2',
  disabled = false,
  downloadDisabled = disabled,
  downloadLabel = 'Download',
  uploadLabel = 'Upload',
}: BulkExcelActionsProps) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  return (
    <div className={containerClassName}>
      {helpTargetId && (
        <p className={helpClassName}>
          <BulkUploadHelp targetId={helpTargetId} />
        </p>
      )}

      <div className={actionsClassName}>
        <button
          type="button"
          className="btn btnexport"
          onClick={onDownload}
          disabled={downloadDisabled}
        >
          <i className="ri-download-2-line align-bottom me-1"></i>
          {downloadLabel}
        </button>

        <input
          type="file"
          accept=".xlsx,.xls"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={e => {
            const file = e.target.files?.[0];
            if (file) void onUpload(file);
            e.currentTarget.value = '';
          }}
        />

        <button
          type="button"
          className="btn btnupload"
          onClick={() => fileInputRef.current?.click()}
          disabled={disabled}
        >
          <i className="ri-upload-2-line align-bottom me-1"></i>
          {uploadLabel}
        </button>
      </div>
    </div>
  );
};

export default BulkExcelActions;
